var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`app-wrapper lo_tb ${_vm.theme}`,staticStyle:{"width":"100vw","height":"100vh","overflow":"hidden"}},[_c('Navbar',{attrs:{"navbar_status":_vm.navbar_status}}),_c('div',{style:(`height:${_vm.navbar_status.show==true?'calc(100% - 100px)':'calc(100% - 60px)'};width:100%;overflow:hidden;`)},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }